/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import Plot from "react-plotly.js";
import {fetchMarketBreadth} from "../../api";


const MarketBreadth = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
          const fetchData = async () => {
              fetchMarketBreadth()
                  .then((data) => setData(data))
                  .catch((error) => console.error("Error fetching market breadth:", error));
          }
          fetchData();
    const interval = setInterval(fetchData, 30000); // Refresh data every 5 sec
    return () => clearInterval(interval);
  }, []);

  if (!data) return <p>Loading market data...</p>;

  return (
    <div style={styles.container}>
      {/* Market Sentiment */}
      <h2>Market Breadth Overview</h2>
      <p
        style={{
          ...styles.sentiment,
          ...(data.market_sentiment === "Bullish"
            ? styles.sentimentBullish
            : data.market_sentiment === "Bearish"
            ? styles.sentimentBearish
            : styles.sentimentNeutral),
        }}
      >
        Market Sentiment: {data.market_sentiment}
      </p>

      <div style={styles.chartContainer}>
        {/* Market Breadth Pie Chart */}
        <div style={styles.chartBox}>
          <Plot
            data={[
              {
                labels: [`Advancing Stocks (${data.advancing_stocks})`, `Declining Stocks (${data.declining_stocks})`, `Unchanged (${data.unchanged_stocks})`],
                values: [
                  data.advancing_stocks,
                  data.declining_stocks,
                  data.unchanged_stocks,
                ],
                type: "pie",
                marker: {
                  'colors': [
                    '#089d08',
                    '#d94141',
                    '#1a93ce'
                  ]
                },
              },
            ]}
            layout={{ title: "Market Breadth Distribution" }}
          />
        </div>
        {/* A/D Line Chart */}
        <div style={styles.chartBox}>
          <Plot
            data={[
              {
                x: ["Advancing - Declining"],
                y: [data.ad_line],
                type: "bar",
                marker: {
                  'color': [
                    data.ad_line > 0 ? '#089d08':'#d94141',
                  ]
                },
              },
            ]}
            layout={{ title: "Advance/Decline Line" }}
          />
        </div>
      </div>
    <div style={styles.container}>
      {/*<h2>% Up Days vs % Down Days (Last 20 Sessions)</h2>*/}

      <div style={styles.chartBox}>
        <Plot
          data={[
            {
              x: ["Up Days", "Down Days"],
              y: [data.percent_up_days, data.percent_down_days],
              type: "bar",
              marker: { color: ["#089d08", "#d94141"] },
            },
          ]}
          layout={{ title: "% Up Days vs % Down Days (Last 20 Sessions)", height: 400, width: 500 }}
        />
      </div>
    </div>
        {/* Total Market Volume */}
      <div style={styles.chartContainer}>
        <div style={styles.chartBox}>
          <Plot
            data={[
              {
                x: ["Total Volume"],
                y: [data.total_market_volume],
                type: "bar",
              },
            ]}
            layout={{ title: "Total Market Volume (Shares)" }}
          />
        </div>
        {/* Most Active Stocks */}
        <div style={styles.chartBox}>
          <Plot
            data={[
              {
                x: Object.keys(data.most_active_stocks),
                y: Object.values(data.most_active_stocks),
                type: "bar",
              },
            ]}
            layout={{ title: "Most Active Stocks by Volume" }}
          />
        </div>
      </div>
    </div>
  );
};

export default MarketBreadth;

  // ✅ Inline CSS styles
  const styles = {
    container: {
      padding: "16px",
      fontFamily: "Arial, sans-serif",
    },
    sentiment: {
      fontSize: "18px",
      fontWeight: "bold",
    },
    sentimentBullish: { color: "green" },
    sentimentBearish: { color: "red" },
    sentimentNeutral: { color: "gray" },
    chartContainer: {
      display: "flex",
      flexWrap: "wrap",
      gap: "20px",
      justifyContent: "space-between",
      marginTop: "20px",
    },
    chartBox: {
      flex: 1,
      minWidth: "400px",
      padding: "10px",
      border: "1px solid #ddd",
      borderRadius: "10px",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      backgroundColor: "white",
    },
  };